// import React from 'react'
// import './Contact.css'
// import msgIcon from '../../assets/edu/msg-icon.png'
// import mailIcon from '../../assets/edu/mail-icon.png'
// import phoneIcon from '../../assets/edu/phone-icon.png'
// import locationIcon from '../../assets/edu/location-icon.png'
// import LazyGoogleMap from './LazyGoogleMap'

// const Contact = () => (
  
//   <section className="contact">
//             {/* Centered Contact Us heading */}
//     <div className="contact-center">
//       <h3>CONTACT US</h3>
//     </div>
//     {/* Column 1: Message & Info */}
//     <div className="contact-col">
      
//       <h3 className="contact-heading">
         
//       </h3>
//       <p className="contact-text">
//         Feel free to reach out through the contact form or find our contact
//         information below. Your feedback, questions, and suggestions are
//         important to us as we strive to provide exceptional service to our
//         community.
//       </p>
//       <ul className="contact-list">
//         <li>
//           <img src={mailIcon} alt="" />
//            <a
//       href={"mailto:lakesideminigolf@gmail.com" + "?subject=" + encodeURIComponent("Inquiry from Website")
//     + "&body=" + encodeURIComponent("Hi there,\n\nI’d like to ...")
//   }
//     style={{ color: 'inherit', textDecoration: 'none' }}
//   >
//     lakesideminigolf@gmail.com
//   </a>
//         </li>
//         <li>
//           <img src={phoneIcon} alt="" />
//           (252) 270-5233
//         </li>
//         <li>
//           <img src={locationIcon} alt="" />
//           3358 River Rd, Henrico, NC 27842
//         </li>
//       </ul>
//     </div>



//     {/* Column 2: Map */}
//     <div className="contact-col">
//       <h3 className="contact-heading">
        
//       </h3>
//       <LazyGoogleMap />
//     </div>
//   </section>
// )

// export default Contact





const Contact = () => (
  <section id="contact" className="parallax">
    <div className="content">
      <h2 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-6">Contact Us</h2>
      <p className="text-lg md:text-xl text-white mb-6">Ready to crank up your fitness? Drop by or hit us up to join B & G Fitness!</p>
      <div className="mb-6 text-[#e0e0e0]">
        <p><strong>Address:</strong> 123 Main St, Tarboro, NC 27886</p>
        <p><strong>Phone:</strong> (252) 555-1234</p>
        <p><strong>Email:</strong> info@bandgfitness.com</p>
      </div>
      <a href="mailto:info@bandgfitness.com" className="inline-block bg-[#32cd32] text-[#222] px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#28a745] hover:scale-105 transition-all">Get in Touch</a>
    </div>
  </section>
);

export default Contact;